import { produce } from "immer";
import {
    AUTH_VERIFY_MOBILE_APP_ACTION,
    AUTH_VERIFY_MOBILE_APP_FAILURE,
    AUTH_VERIFY_MOBILE_APP_SUCCESS
} from "../../mobileAppCore/mobileAppConstants";
import parseAccountName from "../../utils/parseAccountName.js";
import { LOGOUT_SUCCESS } from "../Login/loginConstants.js";
import {
    ADD_MARKET_DATA_CANDLE_WATCH_ACTION,
    ADD_MARKET_DATA_WATCH_ACTION,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS,
    GET_LITE_TRADE_ASSETS_SUCCESS,
    INIT_LITE_TRADE_ACTION,
    INIT_LITE_TRADE_FAILURE,
    INIT_LITE_TRADE_SUCCESS,
    LOGIN_LITE_TRADE_ACTION,
    LOGIN_LITE_TRADE_FAILURE,
    LOGIN_LITE_TRADE_SUCCESS,
    PING_LITE_TRADE_ACTION,
    PING_LITE_TRADE_FAILURE,
    PING_LITE_TRADE_SUCCESS,
    REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION,
    REMOVE_MARKET_DATA_WATCH_ACTION,
    SET_LITE_TRADE_ACCOUNT_METRICS,
    SET_LITE_TRADE_ACCOUNT_PORTFOLIO,
    UPDATE_MARKET_DATA,
    UPDATE_MARKET_DATA_CANDLE,
} from "./liteTradeConstants.js";

const initialState = {
    config: null,
    initError: null,
    isInitLoading: false,

    session: {},

    pingError: null,
    isPingLoading: false,

    loginError: null,
    isLoginLoading: false,

    metrics: {},
    portfolios: {},
    marketDataWatchers: [],
    marketDataCandleWatchers: [],

    marketData: {},
    marketDataCandle: {},

    assets: [],

    authVerifyInProgress: false,

    stat_pl: {},
}

const liteTradeReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {

            case INIT_LITE_TRADE_ACTION:
                draft.initError = null;
                draft.isInitLoading = true;
                break;
            case INIT_LITE_TRADE_SUCCESS:
                draft.config = action.payload;
                draft.isInitLoading = false;
                break;
            case INIT_LITE_TRADE_FAILURE:
                draft.initError = action.payload;
                draft.isInitLoading = false;
                break;

            case PING_LITE_TRADE_ACTION:
                draft.pingError = null;
                draft.isPingLoading = true;
                break;
            case PING_LITE_TRADE_SUCCESS:
                draft.session = action.payload;
                draft.isPingLoading = false;
                break;
            case PING_LITE_TRADE_FAILURE:
                draft.pingError = action.payload;
                draft.isPingLoading = false;
                break;

            case LOGIN_LITE_TRADE_ACTION:
                draft.loginError = null;
                draft.isLoginLoading = true;
                break;
            case LOGIN_LITE_TRADE_SUCCESS:
                draft.session = action.payload;
                draft.isLoginLoading = false;
                break;
            case LOGIN_LITE_TRADE_FAILURE:
                draft.loginError = action.payload;
                draft.isLoginLoading = false;
                break;

            case SET_LITE_TRADE_ACCOUNT_METRICS:
                const accountCodeMetrics = parseAccountName(action.payload.account).accountCode;
                if (!accountCodeMetrics) break;
                draft.metrics[accountCodeMetrics] = action.payload;
                break;

            case SET_LITE_TRADE_ACCOUNT_PORTFOLIO:
                const accountCodePortfolio = parseAccountName(action.payload.account).accountCode;
                if (!accountCodePortfolio) break;
                draft.portfolios[accountCodePortfolio] = action.payload;
                break;

            case GET_LITE_TRADE_ASSETS_SUCCESS:
                draft.assets = action.payload;
                break;

            case LOGOUT_SUCCESS:
                return {
                    ...initialState,
                };

            case AUTH_VERIFY_MOBILE_APP_ACTION:
                draft.authVerifyInProgress = true;
                break;
            case AUTH_VERIFY_MOBILE_APP_SUCCESS:
                draft.authVerifyInProgress = false;
                break;
            case AUTH_VERIFY_MOBILE_APP_FAILURE:
                draft.authVerifyInProgress = false;
                break;

            case UPDATE_MARKET_DATA:
                action.payload.forEach(event => {
                    draft.marketData[event.symbol] = event;
                });
                break;
            case UPDATE_MARKET_DATA_CANDLE:
                action.payload.forEach(event => {
                    if (!draft.marketDataCandle[event.symbol]) {
                        draft.marketDataCandle[event.symbol] = {};
                    }
                    draft.marketDataCandle[event.symbol][event.time] = event;
                });
                break;

            case ADD_MARKET_DATA_WATCH_ACTION:
                draft.marketDataWatchers.push({
                    symbol: action.payload.symbol,
                    fromComponentName: action.payload.fromComponentName,
                });
                break;

            case REMOVE_MARKET_DATA_WATCH_ACTION:
                draft.marketDataWatchers = state.marketDataWatchers
                    .filter(item => !(item.fromComponentName === action.payload.fromComponentName && (!action.payload.symbol || item.symbol === action.payload.symbol)))
                break;

            case ADD_MARKET_DATA_CANDLE_WATCH_ACTION:
                draft.marketDataCandleWatchers.push({
                    symbol: action.payload.symbol,
                    fromComponentName: action.payload.fromComponentName,
                });
                break;

            case REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION:
                draft.marketDataCandleWatchers = state.marketDataWatchers
                    .filter(item => !(item.fromComponentName === action.payload.fromComponentName && (!action.payload.symbol || item.symbol === action.payload.symbol)))
                break;

            case GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS:
                draft.stat_pl = action.payload;
                break;

            default:
                return state;
        }
    });

export default liteTradeReducer;
